import { AbilityTypes } from "../../data/abilities";
import { Ability } from "../abilities/Ability";
import { Stat } from "./Stat";

export class Spell {
  id: string;
  name: string;
  description: string;

  listed: boolean | undefined;
  requires: string[];

  ability: Ability | undefined;
  onAdded: Ability | undefined;

  uses: Stat | undefined;

  cost: number;

  constructor(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;

    this.listed = data.listed;
    this.requires = data.requires;

    if (data.ability) {
      this.ability =
        typeof data.ability === "string"
          ? AbilityTypes[data.ability as keyof typeof AbilityTypes]
          : new Ability(data.ability.name, data.ability);
    }

    if (data.onAdded) {
      this.onAdded =
        typeof data.onAdded === "string"
          ? AbilityTypes[data.onAdded as keyof typeof AbilityTypes]
          : new Ability(data.onAdded.name, data.onAdded);
    }

    if (data.uses) {
      this.uses = new Stat(data.uses || 1, null, true);
    }

    this.cost = data.cost || 0;
  }
}
